export default {
  getRestaurantsList: 'GET_RSETAURANTS_LIST',
  getRestaurantsListSuccess: 'GET_RSETAURANTS_LIST_SUCCESS',
  getRestaurantsListFailed: 'GET_RSETAURANTS_LIST_FAILED',
  addNewRestaurant: 'ADD_NEW_RSETAURANT',
  addNewRestaurantSuccess: 'ADD_NEW_RSETAURANT_SUCCESS',
  addNewRestaurantFailed: 'ADD_NEW_RSETAURANT_FAILED',
  toggleRestaurantForm: 'TOGGLE_RSETAURANT_FORM',
  resetToInitialState: 'RSETAURANT_FORM_RESET_TO_INITIAL_STATE',
  updateRestaurantDetails: 'UPDATE_RSETAURANT_DETAILS',
  updateRestaurantDetailsSuccess: 'UPDATE_RSETAURANT_DETAILS_SUCCESS',
  updateRestaurantDetailsFailed: 'UPDATE_RSETAURANT_DETAILS_FAILED',
  deleteRestaurant: 'DELETE_RESTAURANT',
  deleteRestaurantSuccess: 'DELETE_RESTAURANT_SUCCESS',
  deleteRestaurantFailed: 'DELETE_RESTAURANT_FAILED',
  getCuisinesList: "GET_CUISINES_LIST",
  getCuisinesListSuccess: "GET_CUISINES_LIST_SUCCESS",
  getCuisinesListFailed: "GET_CUISINES_LIST_FAILED",
  getRestaurantDetails: "GET_RESTAURANT_DETAILS",
  getRestaurantDetailsSuccess: "GET_RESTAURANT_DETAILS_SUCCESS",
  getRestaurantDetailsFailed: "GET_RESTAURANT_DETAILS_FAILED"
};
